//The contents of this file have been generated automatically. Do not edit this file.

import * as t from 'io-ts';
import { isRight } from 'fp-ts/lib/Either';
import { fetchGeneralRaw, FetchGeneralRawResponseType } from 'src_common/common/fetch';
import { ApiTimeLog } from 'src_common/server/webDriver/logFormat';


export interface ParamsType {
}


const createGuard = <A>(code: number, decoder: t.Type<A, A, unknown>): ((data: unknown) => A) => {
    return (data: unknown): A => {
        const decodeResult = decoder.decode(data);
        if (isRight(decodeResult)) {
            return decodeResult.right;
        }
        throw Error(`Response decoding error /api-proxy/staff/sports-list -> get -> ${code}`);
    };
};

export const Response200IO = t.array(t.interface({
    defaultGrade: t.union([t.null, t.undefined, t.interface({
        id: t.number,
        name: t.string,
    })]),
    displayOrder: t.number,
    eventTemplates: t.array(t.interface({
        allowCompetitionMultiples: t.union([t.null, t.undefined, t.boolean]),
        antePost: t.union([t.null, t.undefined, t.boolean]),
        id: t.string,
        name: t.union([t.null, t.undefined, t.string]),
        participants: t.union([t.null, t.undefined, t.array(t.interface({
            maxOccurs: t.union([t.null, t.undefined, t.number]),
            minOccurs: t.union([t.null, t.undefined, t.number]),
            role: t.union([t.null, t.undefined, t.string]),
        }))]),
        sportId: t.union([t.null, t.undefined, t.string]),
        url: t.string,
    })),
    grades: t.array(t.interface({
        inPlay: t.union([t.null, t.undefined, t.interface({
            id: t.number,
            name: t.string,
        })]),
        prematch: t.union([t.null, t.undefined, t.interface({
            id: t.number,
            name: t.string,
        })]),
        show: t.union([t.null, t.undefined, t.interface({
            id: t.number,
            name: t.string,
        })]),
    })),
    id: t.string,
    name: t.string,
}));
export type Response200Type = Array<{
    defaultGrade?: null | undefined | {
        id: number;
        name: string;
    };
    displayOrder: number;
    eventTemplates: Array<{
        allowCompetitionMultiples?: null | undefined | boolean;
        antePost?: null | undefined | boolean;
        id: string;
        name?: null | undefined | string;
        participants?: null | undefined | Array<{
            maxOccurs?: null | undefined | number;
            minOccurs?: null | undefined | number;
            role?: null | undefined | string;
        }>;
        sportId?: null | undefined | string;
        url: string;
    }>;
    grades: Array<{
        inPlay?: null | undefined | {
            id: number;
            name: string;
        };
        prematch?: null | undefined | {
            id: number;
            name: string;
        };
        show?: null | undefined | {
            id: number;
            name: string;
        };
    }>;
    id: string;
    name: string;
}>;
export const decodeResponse200 = createGuard(200, Response200IO);

export const Response400IO = t.string;
export type Response400Type = string;
export const decodeResponse400 = createGuard(400, Response400IO);

export const Response401IO = t.string;
export type Response401Type = string;
export const decodeResponse401 = createGuard(401, Response401IO);

export const Response500IO = t.string;
export type Response500Type = string;
export const decodeResponse500 = createGuard(500, Response500IO);



type ExtraHeadersType = Record<string, string>


/**
 * @deprecated - Please use this method "openapiProxyStaffSportsRequest"
 */
export const openapi_proxy_staff_sports = async (api_url: string, api_timeout: number, backendToken: string, _params: ParamsType, extraHeaders?: ExtraHeadersType): Promise<FetchGeneralRawResponseType> => {
    
        
    const query = '';
    const url = `${api_url}/api-proxy/staff/sports-list${query}`;
    
    const method = 'GET';
    const paramsFetch = {
        url,
        body: undefined,
        backendToken,
        timeout: api_timeout,
        extraHeaders,
    };

    const apiTime = ApiTimeLog.createWithProcessEnv(method, url);
    const response = await fetchGeneralRaw(method, paramsFetch);
    apiTime.show(response.status);
    return response;
};


export type OpenapiProxyStaffSportsParamsType = ParamsType;

export type OpenapiProxyStaffSportsResponseType = {
    status: 200;
    body: Response200Type;
} | {
    status: 400;
    body: Response400Type;
} | {
    status: 401;
    body: Response401Type;
} | {
    status: 500;
    body: Response500Type;
};

export type OpenapiProxyStaffSportsResponse200Type = Response200Type;

export const openapiProxyStaffSportsRequest = async (api_url: string, api_timeout: number, backendToken: string, _params: ParamsType, extraHeaders?: ExtraHeadersType): Promise<OpenapiProxyStaffSportsResponseType> => {
    const response = await openapi_proxy_staff_sports(api_url, api_timeout, backendToken, _params, extraHeaders);
    const { status, body } = response;

    let json = null;

    try {
        json = JSON.parse(body);
    } catch (_err) {
        console.warn(`Http status ${status} - json was expected`);
        json = {};
    }
    
    if (status === 200) {
        return { status: 200, body: decodeResponse200(json) };
    }

    if (status === 400) {
        return { status: 400, body: decodeResponse400(json) };
    }

    if (status === 401) {
        return { status: 401, body: decodeResponse401(json) };
    }

    if (status === 500) {
        return { status: 500, body: decodeResponse500(json) };
    }

    throw new Error(`openapiProxyStaffSportsRequest - unhandled response ${response.status}`);
};

